import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AlertMessageService } from '@serpro/ngx-suite-rfb';
import { appRoute } from '../shared/consts/app-routes';
import { UtilService } from '../shared/services/util.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {

    constructor(
        private authService: AuthService,
        private router: Router,
        private util: UtilService,
        private alertMessageService: AlertMessageService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        console.log("canActivate", this.authService.isAuthenticated());
        console.log("route", route);

        if (this.authService.isAuthenticated()) {

            console.log("[AuthGuard] Usuário autenticado!");

            // Recupera os roles que estao na rota.
            // Se nao tiver nenhum, significa que a rota é aberta.
            const routeRoleNames = route.data['roleNames'];
            console.log("[AuthGuard] Roles da rota:", routeRoleNames);
            if (!routeRoleNames) {
                return true;
            }

            // Recupera as roles do usuário (vindas do backend)
            const userRoleNames = this.authService.rolesName.split(',');
            console.log("[AuthGuard] Roles do usuário:", userRoleNames);
            if (this.util.hasIntersection(userRoleNames, routeRoleNames)) {
                return true;
            }

            console.log("[AuthGuard] Proibido!");
            this.alertMessageService.error('Proibido!', 'Você não tem permissão para executar essa transação.');
            return false;
        }

        console.log("[AuthGuard] Usuário não autenticado. Sendo redirecionado para a página de login...");
        this.router.navigate([`${appRoute.login}`], { queryParams: { nextRoute: state.url } });
        return false;
    }
}
